import React from 'react';

import Base from './base.jsx'; 
import {
  castDataType,
  DataType
} from '../common.jsx';
import Setting from "./setting.jsx";


import FileUploadUppy from '../../common/uppy_upload/FileUploadUppy.lazy.jsx';

const ALIGNMENTS = {
    left:'left', 
    center:'center', 
    right:'right'
};
const SCALES = {
    small: 'small', // 30% of the image width or form, depending which one is smaller
    medium: 'medium', // 50% of the form width or 50% of the image width, depending which one is smaller.
    large: 'large' // 100% width of the image or 100% width of the form, depending on which one is smaller.
}
export default class BrandingImages extends Base {

    static get CATEGORY() {
        return 'other';
    }

    static get TYPE() {
        return 'branding_images';
    }

    static icon() {
        return <i className="fa fa-image"></i>;
    }

    static get TRANSLATED_ATTRIBUTES() {
        return {
            label: 'field_default_label',
            description: 'field_default_description'
        };
    }

    constructor(props) {
        super(props);
        
        this.updateScale = this.updateScale.bind(this);
        this.updateFilePath = this.updateFilePath.bind(this);
    }

    static defaultContent(language) {
        return Object.assign(super.defaultContent(language), {
            label: 'label',
            description: 'description',
            label_hidden: false,
            alignment: 'center',
            scale: 'small',
            file_path: ''
        });
    }

    renderView() {
        const {label_hidden, scale, alignment, file_path} = this.props.content
        let imageStyle = {
            width: scale === SCALES['large'] ? '100%' : (scale === SCALES['medium'] ? '50%' : '30%'),
        }
        if (alignment === ALIGNMENTS['left']){
            imageStyle['marginRight'] = 'auto';
        } else if (alignment === ALIGNMENTS['center']){
            imageStyle['marginRight'] = 'auto';
            imageStyle['marginLeft'] = 'auto';
        } else if (alignment === ALIGNMENTS['right']){
            imageStyle['marginLeft'] = 'auto';
        }
        return (
            <div className='d-flex' style={{flexDirection: 'column'}}>
                <label className={label_hidden ? 'hidden-label': ''}>
                    <span className="field-label">{this.getText('label')}</span>
                </label>
                <img src={file_path} style={imageStyle} />
                {this.descriptionText()}
            </div>
        )
    }

    renderSettings() {
        return (
            <div>
                <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
                <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
                {!this.props.settings['hideDescriptionField'] &&
                      <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
                }
                <Setting.Dropdown 
                            name="alignment" 
                            label={I18n.t('text_field_image_alignment', {scope: 'fe'})} 
                            value={this.props.content.alignment || 'center'} 
                            onChange={this.updateSettings} 
                            options={Object.values(ALIGNMENTS).map(a => [a, I18n.t('text_field_align_position', {scope: 'fe', position: a})])} 
                />
                <Setting.Dropdown
                    name="scale"
                    label={I18n.t('image_scale', {scope: 'fe'})}
                    value={this.props.content.scale || 'small'}
                    onChange={this.updateScale}
                    options={Object.values(SCALES).map(o => [o, I18n.t(o)])} 
                />
                <div className="setting">
                    <label>{I18n.t('upload_branding_image')}</label>
                    <FileUploadUppy
                        allowedFileTypes={['image/*']}
                        name='file_path'
                        maxFileSize={2000000}
                        maxNumberOfFiles={1}
                        uploadCallback={this.updateFilePath}
                        permissions={{'public': true}}
                    />
                </div>
            </div>
        )
    }

    beforeUpdateSettings(content) {
        content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
    }

    updateScale(e){
        let content = JSON.parse(JSON.stringify(this.props.content));
        content['scale'] = e.target.value;
        this.props.updateSettingsCallback(this.props.content.id, content, true);
    }

    updateFilePath(e){
        let content = JSON.parse(JSON.stringify(this.props.content));
        content['file_path'] = e.path;
        this.props.updateSettingsCallback(this.props.content.id, content, true);
    }
}